import * as React from "react";
import { usePageContext } from "react-pdf";

/**
 * A placeholder for a page.
 *
 * The page dimensions will be resolved from the given PDF and the component will take up the same amount of space
 * as the rendered page would.
 */
export const Placeholder: React.FC = () => {
  const pageContext = usePageContext();
  const dimensions = {
    width: "0px",
    height: "0px",
  };

  if (pageContext?.page) {
    const scale = pageContext.scale;
    const [x1, y1, x2, y2] = pageContext.page._pageInfo.view;
    dimensions.height = `${(y2 - y1) * scale}px`;
    dimensions.width = `${(x2 - x1) * scale}px`;
  }

  return (
    <div
      data-testid="page-placeholder"
      className="page-placeholder"
      style={dimensions}
    ></div>
  );
};
